import { CustomDateFormatPipe } from '../../../../../../_helpers/_pipes/custom-date-format.pipe';
import { MapfreButtonComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, Input, OnInit } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { CompanyTypeService } from '@services/_iam/company-type.service';
import { EventService } from '@services/event-service.service';
import { PaymentServiceService } from '@services/payment-service/payment-service.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreButtonComponent, CustomDateFormatPipe],
  selector: 'app-bn-makepayment-other-policies',
  templateUrl: './bn-makepayment-other-policies.component.html',
  styleUrls: ['./bn-makepayment-other-policies.component.scss']
})
export class BnMakepaymentOtherPoliciesComponent implements OnInit {

  isNativeApp: boolean;
  currentMinAmtDue: any;
  paymentDate: any;
  isAcmic: boolean;
  outstandingBalance: any;
  @Input() policy: any;

  constructor(
    private paymentService: PaymentServiceService,
    private acmicService: AcmicService,
    private companyTypeService: CompanyTypeService,
    private eventService: EventService
  ) {
    this.isAcmic = this.acmicService.isACMIC();
  }

  // payNow() {
  //   if(this.policy?.policynumber?.policyNumber?.length === 10) {
  //     this.router.navigate(['billing-new', this.policy?.policynumber?.policyNumber, 'make-a-payment']);
  //   } else {
  //     this.onPayByCardBilling(this.policy?.policynumber?.policyNumber, this.policy?.mailingAddress?.zipCode?.code, this.policy?.billingDetails[0]?.amountStillDue);
  //   }
  isNative() {
    this.isNativeApp = Capacitor.isNativePlatform();
  }

  getCheckDigits(policyNumber, checkDigits, company, zipCode, format){
    if (company=='TW')
         return policyNumber + ';' + zipCode;
     else if (company=='ACIC')
         return format.suffix + ';' + format.number
      else 
         return policyNumber + checkDigits;
  }
  getPayBillLink(policy){
    return this.companyTypeService.getPayBill(policy?.residentialAddress?.stateCode, policy?.company, policy?.policynumber?.policyNumber).url
  }
  getPayBillSource(policy){
    return this.companyTypeService.getPayBill(policy?.residentialAddress?.stateCode, policy?.company, policy?.policynumber?.policyNumber).source
  }
  onCreatePaymentForm(accountID, zipCode, minAmount, format, company){
    const minAmountDueonPolicy = Number(minAmount).toFixed(2);
    let xmlResp;
    if (company?.companyName=='TW'){
      xmlResp = `<MiscellaneousData><UserId>B2C</UserId><CompanyNbr>${company.companyId}</CompanyNbr><MinDue>${minAmountDueonPolicy}</MinDue></MiscellaneousData>`;
    } else if (company?.companyName=='ACIC'){
      if (company.companyId=='25')
        xmlResp =   company.companyId + 'B2C'
      else
      xmlResp = `<MiscellaneousData><UserId>B2C</UserId><CompanyNbr>${company?.companyId}</CompanyNbr><MinDue>${minAmountDueonPolicy}</MinDue></MiscellaneousData>`;
    } else {
      xmlResp = `<MiscellaneousData><UserId>${accountID}</UserId><ZipCode>${zipCode}</ZipCode><MinDue>${minAmountDueonPolicy}</MinDue></MiscellaneousData>`;
      }
      return xmlResp;
  }
  payNow(policyNumber, zipCode, minAmount) {
    this.paymentService.setPaymentData(policyNumber, zipCode, minAmount);
    if (policyNumber.length === 10) {
      this.paymentService.redirectToPaymentExpress(
        this.isNativeApp,
        this.isAcmic
      );
    } else {
      this.paymentService.redirectToPayBill(policyNumber, zipCode, minAmount);
    }
  }
  calculateAmounts(policy) {
    if (policy && policy.billingDetails[0]) {
      if (policy.billingDetails[0] && policy.hasPriorYearBalance) {
        this.outstandingBalance =
          policy.billingDetails[0].outstandingbalance +
          policy.priorYearBalance.theAmount;
      } else {
        this.outstandingBalance = policy.billingDetails[0].outstandingbalance;
      }

      if (policy.billingDetails[0] && policy.hasPriorYearBalance) {
        if (
          policy.policyCancellationReason &&
          (policy.policyCancellationReason.toLowerCase() ==
            'pay - non-payment of insurance premium' ||
            policy.policyCancellationReason.toLowerCase() ==
              'fpd - failure to pay deposit') &&
          policy.policyStatus != 'CANCELLED'
        ) {
          this.currentMinAmtDue =
            policy.exitDelinquencyAmount.theAmount +
            policy.priorYearBalance.theAmount;
          this.paymentDate = policy.policyCancellationEffectiveDate;
        } else {
          this.currentMinAmtDue =
            policy.billingDetails[0].amountStillDue +
            policy.priorYearBalance.theAmount;
          this.paymentDate = policy.billingDetails[0].paymentDueDate;
        }
      } else if (
        policy.policyCancellationReason &&
        (policy.policyCancellationReason.toLowerCase() ==
          'pay - non-payment of insurance premium' ||
          policy.policyCancellationReason.toLowerCase() ==
            'fpd - failure to pay deposit') &&
        policy.policyStatus != 'CANCELLED'
      ) {
        this.currentMinAmtDue = policy.exitDelinquencyAmount.theAmount;
        this.paymentDate = policy.policyCancellationEffectiveDate;
      } else {
        this.currentMinAmtDue = policy.billingDetails[0].amountStillDue;
        this.paymentDate = policy.billingDetails[0].paymentDueDate;
      }
    }
  }
  callOnInit() {
    this.calculateAmounts(this.policy);
  }
  ngOnInit(): void {
    this.callOnInit();
  }

}
